/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const GetCounselingWaitingTimesResponseTypename = "GetCounselingWaitingTimesResponse" as const;

/**
 *
 * @export
 * @interface GetCounselingWaitingTimesResponse
 */
export interface GetCounselingWaitingTimesResponse {
  /**
   *
   * @type {number}
   * @memberof GetCounselingWaitingTimesResponse
   */
  waitingTime: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetCounselingWaitingTimesResponse
   */
  readonly __typename?: string;
}

export function GetCounselingWaitingTimesResponseFromJSON(json: any): GetCounselingWaitingTimesResponse {
  return GetCounselingWaitingTimesResponseFromJSONTyped(json, false);
}

export function GetCounselingWaitingTimesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCounselingWaitingTimesResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetCounselingWaitingTimesResponseTypename,

    waitingTime: json["waiting_time"],
  };
}

export function GetCounselingWaitingTimesResponseToJSON(object?: GetCounselingWaitingTimesResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    waiting_time: value.waitingTime,
  };
}
